import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { User } from 'app/classes/user';
import { ExerciseEditorGuard } from 'app/exercise-program/services/exercise-editor.guard';
import { AuthService } from 'app/services/auth.service';
import { DocumentModelFactoryService, DocumentModelType, Exercise } from 'fitforce-document-sync';

@Component({
  selector: 'exercise-selection-list',
  templateUrl: './exercise-selection-list.component.html',
  styleUrls: ['./exercise-selection-list.component.scss'],
})
export class ExerciseSelectionListComponent implements OnInit {
  selectedExercise: Exercise = undefined;
  search: FormControl;
  searchText: string;
  user: User;

  @Input() exercises: Exercise[];
  @Input() loading = false;
  @Output() exerciseSelected: EventEmitter<Exercise> = new EventEmitter<Exercise>();

  get canEdit(): boolean {
    return this.exerciseEditorGuard.canEdit(this.user);
  }

  constructor(
    private formBuilder: FormBuilder,
    private factory: DocumentModelFactoryService,
    private authService: AuthService,
    private exerciseEditorGuard: ExerciseEditorGuard
  ) {}

  ngOnInit() {
    this.search = this.formBuilder.control(undefined);

    this.authService.currentUserObs.subscribe(u => {
      this.user = u;
    });

  }

  selectExercise(exercise: Exercise) {
    this.selectedExercise = exercise;
    this.exerciseSelected.emit(exercise);
  }

  createNewExercise() {
    const newExercise = this.factory.build<Exercise>(DocumentModelType.Exercise);
    newExercise.resources = [];
    this.selectExercise(newExercise);
  }

  saveExercise(exercise: Exercise) {
    this.exercises.push(exercise);
  }
}
